import { useTranslation } from 'react-i18next';
import { Container, Select, Button } from './MobileDetailsVariationSwitchButtonStyledComponents';

type MobileDetailsVariationProps = {
  disabled?: boolean;
  value?: string;
  onChange: (value: string) => void;
  options?: { name: string; value: string }[];
};
export function MobileDetailsVariation({ disabled, value, onChange, options }: MobileDetailsVariationProps) {
  const { t } = useTranslation();

  return (
    <Container>
      <Button label={t('Switch variation')} icon="switch" variant="brand" disabled={disabled} />
      {!disabled && options && (
        <Select value={value} onChange={({ target }) => onChange(target.value)}>
          {options.map(({ name, value }, id) => (
            <option key={id} value={value}>
              {name}
            </option>
          ))}
        </Select>
      )}
    </Container>
  );
}
